<template>
  <el-dialog
    :visible.sync="isShow"
    width="650px"
    :title="isEdit ? '编辑球队' : '添加球队'"
    :close-on-click-modal="false"
    custom-class="yioks_alert"
  >
    <el-form
      v-if="!loading"
      ref="squadForm"
      :model="squadInfo"
      :rules="formRules"
      label-width="120px"
      style="height: 435px"
      class="demo-ruleForm">
      <vue-scroll :ops="ops">
        <el-row v-if="!isEdit">
          <el-col :span="20">
            <el-form-item label="管理单位" prop="organUuid">
              <el-select
                v-model.trim="squadInfo.organUuid"
                style="width: 100%"
                placeholder="请选择管理单位"
                @change="changeOrg">
                <el-option
                  v-for="item in selectOrganList"
                  :key="item.organUuid"
                  :value="item.organUuid"
                  :label="item.organShortName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-else>
          <el-col :span="20">
            <el-form-item label="管理单位" prop="organUuid" >
              <p style="padding-left: 12px">{{squadInfo.organShortName}}</p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="!isEdit">
          <el-col :span="20">
            <el-form-item label="单位" prop="youthUuid">
              <el-select
                v-model.trim="squadInfo.youthUuid"
                style="width: 100%"
                placeholder="请选择管理单位后再选择单位"
                @change="changeCenter(squadInfo.youthUuid)">
                <el-option
                  v-for="item in selectCenterList"
                  :key="item.uuid"
                  :value="item.uuid"
                  :label="item.youthShortName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-else>
          <el-col :span="20">
            <el-form-item label="当前培训机构" prop="youthUuid">
              <p style="padding-left: 12px">{{squadInfo.youthShortName}}</p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="球队类型" prop="squadSex">
              <el-select
                v-model="squadInfo.squadSex"
                placeholder="请选择球队类型"
                @change="changeSex()"
                style="width: 100%">
                <el-option
                  v-for="(item,index) in squadSexList"
                  :key="index"
                  :label="item.value"
                  :value="item.key" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="球队名称" prop="squadName">
              <el-select v-model="squadInfo.squadName" placeholder="请选择球队名称"
                @change="changeName()"
                style="width:100%">
                <el-option
                  v-for="(item,index) in squadNameList"
                  :key="index"
                  :label="item"
                  :value="item" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="球队分支" prop="squadBranch">
              <el-select v-model="squadInfo.squadBranch" placeholder="请选择球队分支"
                         @change="changeBranch()" clearable  @clear="clearBranch" style="width:100%">

                <el-option label="一队" value="一队" />
                <el-option label="二队" value="二队" />
                <el-option label="三队" value="三队" />
                <el-option label="A队" value="A队" />
                <el-option label="B队" value="B队" />
                <el-option label="C队" value="C队" />
                <el-option label="红队" value="红队" />
                <el-option label="黄队" value="黄队" />
                <el-option label="蓝队" value="蓝队" />
                <el-option label="精英队" value="精英队" />
                <el-option label="普通队" value="普通队" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="20">
            <el-form-item label="球员主要出生于" prop="playerBirthdayYear">
              <el-date-picker
                  v-model="squadInfo.playerBirthdayYear"
                  type="year"
                  style="width: 100%"
                  placeholder="请选择球员主要出生年份"
                  value-format="timestamp"
                  disabled
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="isEdit">
          <el-col :span="20">
            <el-form-item label="球队状态" prop="squadDissolve">
              <el-switch
                  v-model="squadInfo.squadDissolve"
                  active-color="#13ce66"
                  inactive-color="#ccc"
                  active-text="已停止"
                  inactive-text="正常"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>

        <!--
        <el-row>
          <el-col :span="20">
            <el-form-item label="球队全称" prop="squadName">
              <el-input v-model.trim="squadInfo.squadName" placeholder="请输入球队全称(50个字以内)"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="球队简称" prop="shortName">
              <el-input v-model.trim="squadInfo.shortName"  placeholder="请输入球队简称(20个字以内)"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="主教练" prop="chiefCoachUuid">
              <el-select
                v-model="squadInfo.chiefCoachUuid"
                placeholder="请选择主教练"
                style="width: 100%"
                @change="adjustCoachList('excuteCoach')" >
                <el-option
                  v-for="(item, index) in nameList"
                  :key="index"
                  :value="item.uuid"
                  :label="item.idName"
                  :disabled="item.disabled"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="领队" prop="leaderUuid">
              <el-select v-model="squadInfo.leaderUuid" placeholder="请选择领队" style="width: 100%" >
                <el-option
                  v-for="(item, index) in leaderList"
                  :key="index"
                  :value="item.uuid"
                  :label="item.idName"
                  :disabled="item.disabled"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="助理教练" >
            <el-row v-for="(item,index ) in  squadInfo.list "  :key="index" style="margin-bottom: 10px" >
              <el-col :span="19">
                <el-col :span="11">
                  <el-select v-model="item.coachUuid" placeholder="请选择助理教练"  @change="adjustCoachList()">
                    <el-option
                      v-for="(item, index) in nameList"
                      :key="index"
                      :value="item.uuid"
                      :label="item.idName"
                      :disabled="item.disabled"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="11" :offset="2">
                  <el-select v-model="item.duty" placeholder="请选择助理教练职责">
                    <el-option
                      v-for="item in positionList"
                      :key="item.uuid"
                      :label="item.duty"
                      :value="item.duty"
                    >
                    </el-option>
                  </el-select>
                </el-col>
              </el-col>
              <el-col :span="4" style="margin-left: 10px">
                <el-button
                  type="primary"
                  circle
                  icon="el-icon-plus"
                  size="mini"
                  @click="addCoachList(index)"></el-button>
                <el-button
                  v-if="squadInfo.list.length > 1"
                  type="danger"
                  circle
                  icon="el-icon-minus"
                  size="mini"
                  @click="removeCoachList(index)"></el-button>
              </el-col>
            </el-row>
          </el-form-item>
        </el-row> -->
        <el-form-item label="上传logo">
          <UploadImg :imgUrl.sync='squadInfo.banner '  :avatarUrl.sync="img" />
          <div>支持jpg,jpeg,bmp,gif,png格式上传</div>
        </el-form-item>
      </vue-scroll>
    </el-form>
    <div v-if="!loading" class="tip">带 * 号的为必填项</div>
    <div v-if="!loading" class="dialog_btn_wrap">
      <el-button
        type="primary"
        style="margin-right:20px"
        :loading="addbtnLoading"
        @click="addSquadCount"
      >确认</el-button>
      <el-button type="danger" @click="isShow = false">取消</el-button>
    </div>
    <yioks-loading v-if="loading" style="height: 500px" />
  </el-dialog>
</template>

<script>
import squadFormRule from '@/utils/formRules/squad'
import { squadSexList } from '@/utils/yioks_data'
import { squadPlayerSex } from '@/utils/yioks_filter'
import storage from '@/utils/storage'
import { ops } from '@/utils/scrollIndialog'
import squadDuty from '@/api/squadDuty'
import squad from '@/api/squad'
import coach from '@/api/coach'
import moment from 'moment/moment'
export default {
  name: 'index',
  components: {
    'UploadImg': () => import('@/components/UploadImg')
  },
  filters: {
    squadPlayerSex
  },
  mixins: [squadFormRule],
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    organList: {
      type: Array,
      required: false
    },
    centerList: {
      type: Array,
      required: false
    },
    addSquad: {
      type: Boolean,
      required: true
    },
    squad: {
      type: Object,
      required: false
    },
    squadUuid: {
      type: String,
      required: false
    }
  },
  data () {
    const squadNameList = []
    for (let i = 5; i <= 22; i++) {
      squadNameList.push('U' + i)
    }
    return {
      img: '',
      squadInfo: {
        banner: '',
        squadName: '',
        squadBranch: '',
        shortName: '',
        chiefCoachName: '',
        youthShortName: '',
        organShortName: '',
        leaderUuid: '',
        chiefCoachUuid: '',
        playerBirthdayYear: '',
        squadDissolve: false,
        list: [
          {
            coachUuid: '',
            duty: '',
            master: false
          }
        ],
        organUuid: '',
        youthUuid: '',
        uuid: '',
        squadSex: ''
      },
      nameList: [],
      selectOrganList: [],
      selectCenterList: [],
      loading: false,
      leaderList: [],
      positionList: [],
      addbtnLoading: false,
      userRole: storage.get('userInfo').userRole,
      uuid: storage.get('userInfo').uuid,
      ops,
      squadNameList,
      squadSexList
    }
  },
  computed: {
    isShow: {
      get () {
        return this.addSquad
      },
      set (val) {
        this.$emit('update:addSquad', val)
      }
    }
  },
  watch: {
  //   'squadInfo.organUuid': {
  //     handler (val) {
  //       if (val) {
  //         this.selectCenterList = this.selectOrganList.find(item => {
  //           return item.organUuid === this.squadInfo.organUuid
  //         }).youthList
  //         this.squadInfo.organShortName = this.selectOrganList.find(item => {
  //           return item.organUuid === this.squadInfo.organUuid
  //         }).organShortName
  //       }
  //     }
  //   }

    "squadInfo.squadName": {
      handler: function(val) {
        const reg = /\（.*$/
        let squadName = val.replace(reg, '')
        const num = squadName.slice(1);
        // 根据监听球队级别，计算球员的最大年份
        const data = new Date();
        this.squadInfo.playerBirthdayYear = data.setFullYear(data.getFullYear() - num);
      }
    },

  },
  created () {
    if (this.squadUuid) {
      this.getSquadInfo()
    }
    this.getOrganListAndCenterList()
    // this.getDutyList()
  },
  methods: {
    getSquadInfo () {
      this.loading = true
      squad.getSquadInfo(this.squadUuid).then(res => {
        const { coaches, leaders } = res
        const squadInfo = res.squad
        let list = []
        coaches.forEach(item => {
          if (!item.master) {
            list.push({
              master: false,
              duty: item.duty,
              coachUuid: item.uuid
            })
          }
        })
        if (list.length < 1) list = [{ master: false, duty: '', coachUuid: '' }]
        this.squadInfo = {
          ...squadInfo,
          list,
          banner: squadInfo.banner || '',
        }
        let request
        if (this.userRole === 'system' || this.userRole === 'admin') {
          request = squad.getCoachListSystem
        } else if (this.userRole === 'organ') {
          request = squad.getCoachListOrgan
        } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
          request = squad.getCoachListYouth
        }
        request({ youthUuid: squadInfo.youthUuid }).then(res => {
          const { coachOptionVos, leaderOptionVos } = res
          this.nameList = coachOptionVos.concat(coaches)
          this.nameList = this.nameList.map(item => {
            if (this.squadInfo.chiefCoachUuid === item.uuid || list.every(itm => itm.coachUuid === item.uuid)) {
              item.disabled = true
            } else {
              item.disabled = false
            }
            return item
          })
          this.leaderList = leaderOptionVos.concat(leaders)
          this.loading = false
        })
      })
    },
    addSquadCount () {
      this.$refs['squadForm'].validate(valid => {
        if (valid) {
          this.addbtnLoading = true
          let requestName = squad.addSquad
          let playerSex = squadPlayerSex(this.squadInfo.squadSex)
          let squadBranch = this.squadInfo.squadBranch;
          const reg = /\（.*$/
          let squadName = this.squadInfo.squadName.replace(reg, '')
          let requestData = {
            squad: {
              squadName: squadBranch === "" ? squadName + '（' + playerSex + '）' : squadName + '（' + playerSex + '）' +  '（' + squadBranch + '）',
              squadBranch: this.squadInfo.squadBranch,
              squadLevel: squadName,
              // shortName: this.squadInfo.shortName,
              organUuid: this.squadInfo.organUuid,
              organShortName: this.squadInfo.organShortName,
              youthUuid: this.squadInfo.youthUuid,
              youthShortName: this.squadInfo.youthShortName,
              // chiefCoachName: this.squadInfo.chiefCoachName,
              // leaderUuid: this.squadInfo.leaderUuid,
              // chiefCoachUuid: this.squadInfo.chiefCoachUuid,
              banner: this.squadInfo.banner,
              squadSex: this.squadInfo.squadSex,
              playerBirthdayYear: this.squadInfo.playerBirthdayYear,
              squadDissolve: this.squadInfo.squadDissolve,
            }
            // coaches: this.squadInfo.list[0].coachUuid ? this.squadInfo.list : []
          }
          // 编辑球队时，data 加上 uuid，接口名改变
          if (this.isEdit) {
            requestName = squad.updataSquad
            requestData.squad.uuid = this.squadInfo.uuid
          }
//          return
          requestName(requestData).then(res => {
            this.addbtnLoading = false
            // 重复处理
            if (res.code) {
              this.$message.error(res.msg)
            } else {
              this.$emit('hideAddsquadDialog', false)
              if (!this.isEdit) {
                this.$router.push({
                  path: 'detail',
                  query: { uuid: res.uuid }
                })
              }
            }
          }).catch(err => {
            this.addbtnLoading = false
            console.error(err)
          })
        }
      })
    },
    getOrganListAndCenterList () {
      let data = this.uuid
      let request
      if (this.userRole === 'organ') {
        request = coach.getCenterListByOrgan
      } else if (this.userRole === 'system' || this.userRole === 'admin') {
        request = coach.getCenterListBySystem
        data = ''
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = coach.getCenterListByYouth
      }
      request(data).then((res) => {
        this.selectOrganList = res
        if (this.selectOrganList.length === 1) {
          this.squadInfo.organUuid = this.selectOrganList[0].organUuid
          this.squadInfo.organShortName = this.selectOrganList[0].organShortName
          this.selectCenterList = this.selectOrganList[0].youthList || []
          if (this.selectCenterList.length === 1) {
            this.squadInfo.youthUuid = this.selectCenterList[0].uuid
            this.squadInfo.youthShortName = this.selectCenterList[0].youthShortName
            this.getCoachList(this.squadInfo.youthUuid)
          }
        }
      })
    },
    getDutyList () {
      squadDuty.getAllDuty().then(res => {
        this.positionList = res
      })
    },
    changeCenter (youthUuid) {
      this.squadInfo.youthShortName = this.selectCenterList.find(item => {
        return item.uuid === this.squadInfo.youthUuid
      }).youthShortName
      if (youthUuid) {
        this.getCoachList(youthUuid)
        // this.getLeaderList(youthUuid)
        this.$set(this.squadInfo, 'chiefCoachUuid', '')
        this.$set(this.squadInfo, 'leaderUuid', '')
        this.$set(this.squadInfo, 'list', [{ coachUuid: '', duty: '', master: false }])
      }
    },
    getCoachList (youthUuid) {
      let request
      if (this.userRole === 'system' || this.userRole === 'admin') {
        request = squad.getCoachListSystem
      } else if (this.userRole === 'organ') {
        request = squad.getCoachListOrgan
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = squad.getCoachListYouth
      }
      request({ youthUuid }).then(res => {
        this.nameList = res.coachOptionVos
        this.leaderList = res.leaderOptionVos
      })
    },
    addCoachList () {
      this.squadInfo.list.push({
        coachUuid: '',
        duty: '',
        master: false
      })
    },
    removeCoachList (index) {
      this.squadInfo.list.splice(index, 1)
      this.adjustCoachList()
    },
    changeCoach (val, type) {
      let list = []
      this.squadInfo.list.forEach(item => {
        if (item.coachUuid) list.push(item.coachUuid)
      })
      if (type === 'excuteCoach') {
        this.squadInfo.chiefCoachName = this.nameList.find(item => item.uuid === this.squadInfo.chiefCoachUuid).idName
      }
      this.nameList = this.nameList.map(item => {
        if (this.squadInfo.chiefCoachUuid === item.uuid || list.includes(item.uuid)) {
          item.disabled = true
        } else {
          item.disabled = false
        }
        return item
      })
    },
    adjustCoachList (type) {
      let list = []
      this.squadInfo.list.forEach(item => {
        if (item.coachUuid) list.push(item.coachUuid)
      })
      if (type === 'excuteCoach') {
        this.squadInfo.chiefCoachName = this.nameList.find(item => item.uuid === this.squadInfo.chiefCoachUuid).idName
      }
      this.nameList = this.nameList.map(item => {
        if (this.squadInfo.chiefCoachUuid === item.uuid || list.includes(item.uuid)) {
          item.disabled = true
        } else {
          item.disabled = false
        }
        return item
      })
    },
    changeOrg () {
      this.$set(this.squadInfo, 'youthUuid', '')
      this.$set(this.squadInfo, 'youthShortName', '')
      if (this.squadInfo.organUuid) {
        this.squadInfo.organShortName = this.selectOrganList.find(item => {
          return item.organUuid === this.squadInfo.organUuid
        }).organShortName
        this.selectCenterList = this.selectOrganList.find(item => {
          return item.organUuid === this.squadInfo.organUuid
        }).youthList || []
        if (this.selectCenterList.length === 1) {
          this.squadInfo.youthUuid = this.selectCenterList[0].uuid
          this.squadInfo.youthShortName = this.selectCenterList[0].youthShortName
          this.getCoachList(this.squadInfo.youthUuid)
        }
      } else {
        this.selectCenterList = []
      }
    },
    changeSex(){
      if(this.squadInfo.squadName !=='' && this.squadInfo.squadBranch !==''){
        const reg = /\（.*$/;
        let playerSex = squadPlayerSex(this.squadInfo.squadSex);
        let squadBranch = this.squadInfo.squadBranch;
        this.squadInfo.squadName = this.squadInfo.squadName.replace(reg, '') + '（' + playerSex + '）' + '（' + squadBranch + '）'
      }
      if (this.squadInfo.squadName !=='' && this.squadInfo.squadBranch ===''){
        const reg = /\（.*$/;
        let playerSex = squadPlayerSex(this.squadInfo.squadSex);
        this.squadInfo.squadName = this.squadInfo.squadName.replace(reg, '') + '（' + playerSex + '）'
      }
    },
    changeName(){
      if(this.squadInfo.squadSex !=='' && this.squadInfo.squadBranch !==''){
        const reg = /\（.*$/;
        let playerSex = squadPlayerSex(this.squadInfo.squadSex);
        let squadBranch = this.squadInfo.squadBranch;
        this.squadInfo.squadName = this.squadInfo.squadName.replace(reg, '') + '（' + playerSex + '）' + '（' + squadBranch + '）'
      }
      if (this.squadInfo.squadSex !=='' && this.squadInfo.squadBranch ===''){
        const reg = /\（.*$/;
        let playerSex = squadPlayerSex(this.squadInfo.squadSex);
        this.squadInfo.squadName = this.squadInfo.squadName.replace(reg, '') + '（' + playerSex + '）'
      }
      if (this.squadInfo.squadSex ==='' && this.squadInfo.squadBranch !==''){
        const reg = /\（.*$/;
        let squadBranch = this.squadInfo.squadBranch;
        this.squadInfo.squadName = this.squadInfo.squadName.replace(reg, '') + '（' + squadBranch + '）'
      }
    },
    changeBranch(){
      if (this.squadInfo.squadName !=='' && this.squadInfo.squadSex !==''){
        const reg = /\（.*$/;
        let playerSex = squadPlayerSex(this.squadInfo.squadSex);
        let squadBranch = this.squadInfo.squadBranch;
        this.squadInfo.squadName = this.squadInfo.squadName.replace(reg, '') + '（' + playerSex + '）' + '（' + squadBranch + '）'
      }
      if (this.squadInfo.squadName !=='' && this.squadInfo.squadSex ===''){
        const reg = /\（.*$/;
        let squadBranch = this.squadInfo.squadBranch;
        this.squadInfo.squadName = this.squadInfo.squadName.replace(reg, '') + '（' + squadBranch + '）'
      }
    },
    clearBranch(){
      if (this.squadInfo.squadName !=='' && this.squadInfo.squadSex !==''){
        const reg = /\（.*$/;
        let playerSex = squadPlayerSex(this.squadInfo.squadSex);
        this.squadInfo.squadName = this.squadInfo.squadName.replace(reg, '') + '（' + playerSex + '）'
      }else if(this.squadInfo.squadName !=='' && this.squadInfo.squadSex ===''){
        const reg = /\（.*$/;
        this.squadInfo.squadName = this.squadInfo.squadName.replace(reg, '')
      }
    }
  }
}
</script>

<style scoped lang="stylus">
  .tip
    color red
    width 100%
    margin-left: 50px;
    word-break break-word
</style>
